<!-- <div class="row">
    
    
  </div> -->
<div class="row ss-top-menu">
  <div class="rk-ui-notification err" *ngIf="msgError" style="z-index: 10000 !important">
      <span id="notificationMessageText">{{errorMessages}}</span>
      <a class="close link" data-dismiss="alert">×</a>
    </div>
    <div class="rk-ui-notification" *ngIf="successError">
      <span id="notificationMessageText">{{successMessages}}</span>
      <a class="close link" data-dismiss="alert">×</a>
    </div>
  
  <div class="col-sm-12">
    <span class="ss-link addCursor" routerLink="/" style="vertical-align: -webkit-baseline-middle;">Dashboard</span>
    <span style="vertical-align: -webkit-baseline-middle;"> <i class="rightArrow fa fa-angle-right"></i> </span>
    <!-- <span class="ss-link capitalize addCursor" [routerLink]="['/../../../projects/view/'+projectId]" *ngIf="pname">{{pname}} <i class="rightArrow fa fa-angle-right"></i> </span> -->
    <span class="ss-link addCursor" (click)="backClicked()"
      style="vertical-align: -webkit-baseline-middle;">PROPOSALs</span>
    <span style="vertical-align: -webkit-baseline-middle;"> <i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-text-dark" style="vertical-align: -webkit-baseline-middle;">View</span>
    <!-- <button class="btn btn-outline-secondary pull-right btn-lg bt-boq" type="button" data-toggle="modal" data-target="#addProductModal" (click)="getCatalogueProducts('all','all')">Add Product</button> -->
  </div>
</div>

<div id="navcontainer">
  <div class="row" *ngIf="customer_status=='proposal_shared' && state == 'boq'">
    <div class="col-12 pull-right mt-3 margin-chng">
      <select class="form-control col-sm-5 select-chng " (change)="filterBoq($event)">
        <option value="all">All</option>
        <option value="yes">Approved</option>
        <option value="no">Rejected</option>
      </select>
    </div>

  </div>
  <div class="row">
    <div class="col-12" *ngIf="erroralert">
      <div class="alert-box grid-100" *ngIf="errorMessage">
        <div class="alert alert-danger mt-3 text-center">
          <a class="close link" data-dismiss="alert" (click)="erroralert=false">×</a>
          {{errorMessage}}
        </div>
      </div>
    </div>
    <div class="col-12" *ngIf="successalert">
      <div class="alert-box grid-100" *ngIf="successMessage">
        <div class="alert alert-success mt-3 text-center">
          <a class="close link" data-dismiss="alert" (click)="successalert=false">×</a>
          {{successMessage}}
        </div>
      </div>
    </div>
  </div>


  <div class="col-12 mt-2 mb-1" *ngIf="role == 'designer' && draft_check == 'yes'">
    <div class="pull-right">
      <button class="btn pull-right btn-lg bt-boq" type="button" data-toggle="modal" data-target="#myProposal">Edit
        Proposal</button>


    </div>
  </div>
  <ul class="nav nav-tabs tabs-chng" id="myTab" role="tablist">
    <li class="nav-item nav-items">
      <a class="nav-link active addCursor text-center mr-3" (click)="selectSet('boq')"
        [ngClass]="{'active': state == 'boq'}">BOQ</a>
    </li>
    <li class="nav-item nav-items">
      <a class="nav-link  addCursor text-center mr-3" (click)="selectSet('ppt')"
        [ngClass]="{'active': state == 'ppt'}">Created PPT</a>
    </li>
    <li class="nav-item nav-items">
      <a class="nav-link  addCursor text-center mr-3" (click)="selectSet('uploaded_ppt')"
        [ngClass]="{'active': state == 'uploaded_ppt'}">Uploaded PPT</a>
    </li>

  </ul>
</div>

<div class="container-fluid container-set">
  <div class="row" style="padding: 16px" *ngIf="this.state == 'boq'">
    <div class="col-md-12">
      <div class="tableDiv " *ngIf="boq_list && boq_list.length>0">
        <div class="table-responsive">
          <table class="table ">
            <thead class="thead-dark">
              <tr>
                <th scope="col" class="firstTh">#</th>
                <th scope="col">REFERENCE NUMBER</th>
                <th scope="col">STATUS</th>
                <th scope="col">PRICE (&#8377;)</th>
                <th scope="col">PERCENT DISCOUNT</th>
                <th scope="col" style="min-width: 9rem;">PROMOTION APPILED</th>
                <th scope="col">PROJECT MANAGEMENT FEE (&#8377;)</th>
                <th scope="col">FINAL AMOUNT (&#8377;)</th>
                <th scope="col">DISCOUNT STATUS</th>
                <th scope="col">CUSTOMER STATUS</th>
                <!-- <th scope="col" *ngIf="propose_type =='final_design'">Category Status</th>
                  <th scope="col" *ngIf="propose_type =='final_design'">CM Status</th>
                  <th scope="col" *ngIf="propose_type =='final_design'">CAD Status</th> -->
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th class="lastTh"></th>
                <th class="lastTh"></th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let proposed_boq of boq_list; let i = index;">
              <tr [attr.data-index]="i" class="box-list">
                <td>{{ i +1 }}</td>
                <td>
                  <span class="text-capitalize cancelled" *ngIf="proposed_boq.quotation.boq_status === 'cancelled' "> cancelled </span>
                  <a
                    [routerLink]="['/lead/'+lead_id+'/project/'+project_id+'/boq_modular/'+proposed_boq.quotation.id]"
                    class="a_hrefLink" routerLinkActive='active'>{{proposed_boq.quotation.reference_number}}</a><br>
                  <p class="fontCh">({{ proposed_boq.quotation['customer_viewing_option'] }})</p>
                </td>
                <td>{{ proposed_boq.quotation.status }}</td>
                <td>{{ proposed_boq.quotation.net_amount }}</td>
                <td>
                  <!-- <span *ngIf="role == 'designer'">
                      {{ proposed_boq.discount_value }}
                    </span> -->
                  <span
                    *ngIf="(role =='city_gm' || role=='business_head' || role=='community_manager' || role=='design_manager' || role == 'designer') && ['rejected','accepted','no_discount'].includes(proposed_boq.discount_status)==true ">
                    {{ proposed_boq.discount_value }}
                  </span>
                  <span
                    *ngIf="(role =='city_gm' || role=='business_head' || role=='community_manager' || role=='design_manager' || role == 'designer') && ['rejected','accepted','no_discount'].includes(proposed_boq.discount_status)==false">
                    <input type="number" step="0.01" min="0.01" max="100" class="discountInput form-control"
                      value="{{proposed_boq.discount_value}}" id="boq_{{ proposed_boq.quotation.id }}"
                      (input)="onInputDiscount($event,proposal,i,proposed_boq.quotation.id)" style="    width: 4rem;">
                  </span>
                </td>
                <td class="">
                  <ng-container *ngIf="proposed_boq.quotation.promo_jobs.length > 0">
                    <ng-container *ngFor="let promo of proposed_boq.quotation.promo_jobs">
                      <div>
                        {{promo.code}}
                        (-{{promo.promo_display_value}})
                        <i class="fa fa-close addCursor" style="font-size: 12px"
                          (click)="deletePromoCode(promo.id,proposed_boq.quotation.id)"
                          *ngIf="['rejected','accepted'].includes(proposed_boq.discount_status)==false"></i>
                      </div>
                    </ng-container>
                  </ng-container>
                </td>
 
                <td style="text-align:center"> {{ proposed_boq.quotation.pm_fee || 0 }}</td>
                <td>
                  <span *ngIf="role == 'designer'">
                    {{ proposed_boq.final_amount  |  number : '1.2-2' }}
                  </span>
                  <span
                    *ngIf="role =='city_gm' || role=='business_head' || role=='community_manager' || role=='design_manager'">
                    {{ final_amt[i] |  number : '1.2-2' }}
                  </span>
                </td>
                <td>{{ proposed_boq.discount_status | replaceChar }}</td>

                <ng-container *ngIf="propose_type =='final_design'">
                  <td>{{proposed_boq.customer_status}}</td>
                </ng-container>

                <!-- <ng-container *ngIf="propose_type =='final_design'">
                   
                    <td *ngIf="proposed_boq.quotation.category_approval == true">Accepted</td>
                    <td *ngIf="proposed_boq.quotation.category_approval == false"> Rejected</td>
                    <td *ngIf="proposed_boq.quotation.category_approval != false && proposed_boq.quotation.category_approval != true"> Pending</td>
                    <td *ngIf="proposed_boq.quotation.cm_approval == true"> Accepted</td>
                    <td *ngIf="proposed_boq.quotation.cm_approval == false"> Rejected</td>
                    <td *ngIf="proposed_boq.quotation.cm_approval != false && proposed_boq.quotation.cm_approval != true"> Pending</td>
                    <td *ngIf="proposed_boq.have_approved_cad_files == true">Uploaded</td>
                    <td *ngIf="proposed_boq.have_approved_cad_files != true">Not Uploaded</td>
                  </ng-container> -->
                <ng-container *ngIf="propose_type =='initial_design'">
                  <td>{{proposed_boq.customer_status}}</td>
                </ng-container>
                <td>
                  <a class="pop approve-yes" data-trigger="hover" title="Remarks"
                    [attr.data-content]="proposed_boq.remark " (mouseenter)="openpopup($event)"
                    *ngIf="customer_status == 'proposal_shared' && proposed_boq.is_approved == 'yes' ">Approved</a>
                  <a class="pop approve-no" data-trigger="hover" title="Remarks"
                    [attr.data-content]="proposed_boq.remark " (mouseenter)="openpopup($event)"
                    *ngIf="customer_status == 'proposal_shared' && proposed_boq.is_approved == 'no' ">Rejected</a>
                </td>
                <!-- discount functionality for different role here -->
                <td style="padding: 0px;">
                  <!-- <div class="row" *ngIf="role =='city_gm'|| role=='community_manager'"> -->
                  <!-- <div class="col-md-6"
                    *ngIf="['rejected','accepted','no_discount'].includes(proposed_boq.discount_status)==false && proposed_boq.quotation.promo_jobs.length <= 0">
                    <button type="button" style="padding: 3px;font-size: 12px;"
                      class="btn btn-primary btn-success cursor-pointer"
                      (click)="confirmAndApprove('accepted',proposed_boq.proposed_doc_id)">Approve Discount/Promotion</button>
                    <button *ngIf="role =='community_manager' && proposed_boq.is_discount_cm_approved ==false" type="button" style="padding: 0px;" class="btn btn-primary btn-sm btn-success cursor-pointer" (click)="confirmAndApprove('accepted',proposed_boq.proposed_doc_id)">Approve Discount</button>
                    <button *ngIf="role =='city_gm' && proposed_boq.is_discount_gm_approved ==false && proposed_boq.discount_value > 10" type="button" style="padding: 0px;" class="btn btn-primary btn-sm btn-success cursor-pointer" (click)="confirmAndApprove('accepted',proposed_boq.proposed_doc_id)">Approve Discount</button>
                  </div> -->
                  <ng-container *ngIf="role!= 'area_sales_manager'" >
                  <div class="col-md-6"
                    *ngIf="['no_discount','proposed_for_discount'].includes(proposed_boq.discount_status)==true && proposed_boq.quotation.promo_jobs.length > 0">
                    <button type="button" style="padding: 3px;font-size: 12px;"
                      class="btn btn-primary btn-success cursor-pointer mb-1"
                      (click)="confirmAndApprove('accepted',proposed_boq.proposed_doc_id)">Approve Discount/Promotion</button>
                      <button type="button" style="padding: 3px;font-size: 12px;"
                      class="btn btn-primary btn-danger cursor-pointer"
                      (click)="rejectnewpromo('rejected',proposed_boq.proposed_doc_id)">Reject Discount/Promotion</button>
                  </div>
                  </ng-container>
                  <!-- </div>  -->
                  <!-- <div class="row" *ngIf="role=='business_head'">
                        <div class="col-md-6" *ngIf="['rejected','accepted','no_discount'].includes(proposed_boq.discount_status)==false">
                          <button *ngIf="proposed_boq.discount_value > 15" type="button" style="padding: 0px;" class="btn btn-primary btn-sm btn-success cursor-pointer" (click)="confirmAndApprove('accepted',proposed_boq.proposed_doc_id)">Approve Discount.</button>
                        </div>
                      </div>   -->
                </td>
                <td>
                  <input type="button" name="" class="btn btn-pink pull-right bt-boq mr-5" value="Add Payment"
                    *ngIf="customer_status == 'proposal_shared' && proposed_boq.is_approved == 'yes' "
                    data-toggle="modal" data-target="#addPayment" (click)="addPayment(proposed_boq.quotation.id)">
                </td>
                <td>
                  <input type="button" name="" class="btn btn-pink pull-right bt-boq mr-5" value="Payment History"
                    *ngIf="customer_status == 'proposal_shared' && proposed_boq.is_approved == 'yes' "
                    data-toggle="modal" data-target="#paymentHistory"
                    (click)="paymentHistory(proposed_boq.quotation.id)">
                </td>
                <td  *ngIf="proposed_boq.quotation.status === 'shared' && proposed_boq.quotation.boq_status != 'cancelled'  "><button data-toggle="modal" data-target="#priceMatchrequest" class="price_match" (click)="getPriceDetails(proposed_boq.quotation.id,proposed_boq.quotation.project_id)">Price Match</button></td>
                <!--  <td> <i class="fa fa-trash deleteRow addCursor" id="delete_row{{i}}" (click)="removeProductToProposals(proposed_boq.id)"></i></td> -->
                 <!-- <td>
                  <i class="fa fa-angle-down" id="delete_row{{i}}"></i>
                </td> -->
              </tr>
              <ng-container *ngIf ="proposed_boq.quotation.promo_jobs.length >0">
                        <tr>
                          <th scope="col" >Promo Code</th>
                          <th scope="col" colspan="4"  class="padd-right">Promo Categories</th>
                          <th scope="col"  class="padd-right">Total Outflow </th>
                        </tr>
                <tr *ngFor = "let data of  proposed_boq.quotation.promo_jobs">
                  <td style="vertical-align: bottom;">{{data.code}}</td>


                  <!-- <td>
                    <tr *ngFor = "let cat of data.promo_category_offers">
                      <td class="text-capitalize">{{cat.category | replaceChar  }}</td>
                      <td>{{cat.promo_value  }}</td>
                      <td>{{cat.promo_discount_percent}}</td>
                    </tr>
                  </td> -->


                  <td colspan="4">
                    <div class="d-flex justify-content-between">
                      <div class="" style="font-weight: bold;">Type</div>
                      <div class="" style="font-weight: bold; margin-left: 5.7rem;">Value</div>
                      <div style="font-weight: bold;">Percentage</div>
                    </div>
                    <div class="d-flex justify-content-between"  *ngFor = "let cat of data.promo_category_offers">
                      <div class="text-capitalize w-50">{{catformat(cat.category) | replaceChar  }}</div>
                      <div style="margin-right: 2.5rem;">₹{{cat.promo_value}}</div>
                      <div style="margin-right:  2.5rem">{{cat.promo_discount_percent}}%</div>
                    </div>
                  </td>
                  <td style="vertical-align: bottom;">{{data.outflow}}</td>
                </tr>
              </ng-container>
            </ng-container>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-md-12 not-found " *ngIf="boq_list && boq_list.length== 0">
        <div class="boq-img">
          <img src="../../../assets/img/desktop.png" style="height: 250px;width: 300px">
        </div>
        <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">Nothing to show...</p>
      </div>
    </div>

  </div>


  <!-- List For PPt -->
  <div class="row" style="padding: 16px" *ngIf="ppt_list && this.state == 'ppt' && ppt_list.length > 0">

    <div class="col-md-4" *ngFor="let obj of ppt_list;let i = index" [attr.data-index]="i">
      <div class="card myCard mb-4">
        <img class="card-img-top px-2 pt-2" src="../../../assets/img/customer/pptview.png" alt="Card image cap">
        <div class="card-body py-2">
          <p class="card-text mb-0 text-card">
            {{ obj.presentation.title }}
          </p>
          <p class="norm-text">
            Created At: <span>{{ obj.presentation.created_at | date:"dd MMMM, y" }}</span>

          </p>
          <p class="norm-text">Updated At:<span>{{ obj.presentation.updated_at | date:"dd MMMM, y" }}</span></p>
        </div>
      </div>
    </div>

  </div>
  <div class="row" *ngIf="ppt_list && this.state == 'ppt' && ppt_list.length == 0">
    <div class="col-md-12 not-found ">
      <div class="boq-img">
        <img src="../../../assets/img/desktop.png" style="height: 250px;width: 300px">
      </div>
      <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">Nothing to show...</p>
    </div>

  </div>
  <!-- List For Uploaded PPT -->
  <div class="row" style="padding: 16px"
    *ngIf="uploaded_ppt_list && this.state == 'uploaded_ppt' && uploaded_ppt_list.length > 0">
    <div class="col-md-4" *ngFor="let obj of uploaded_ppt_list;let i = index" [attr.data-index]="i">
      <div class="card myCard mb-4">
        <img class="card-img-top px-2 pt-2" src="../../../assets/img/customer/pptview.png" alt="Card image cap">
        <div class="card-body py-2">
          <p class="card-text mb-0 text-card">
            {{ obj.uploaded_presentation.name }}
          </p>
          <p class="norm-text">
            Uploaded At: <span>{{ obj.uploaded_presentation.upload_updated_at | date:"dd MMMM, y" }}</span>

          </p>
          <p class="norm-text">Updated At:<span>{{ obj.uploaded_presentation.updated_at | date:"dd MMMM, y" }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="uploaded_ppt_list && this.state == 'uploaded_ppt' && uploaded_ppt_list.length == 0">
    <div class="col-md-12 not-found ">
      <div class="boq-img">
        <img src="../../../assets/img/desktop.png" style="height: 250px;width: 300px">
      </div>
      <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">Nothing to show...</p>
    </div>

  </div>
  <!--  -->
</div>


<!--Price Match Modal-->
<div id="priceMatchrequest" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg" style="min-width: 91%;">


    <div class="modal-content modal-change">
      <div class="modal-header" style="justify-content: end; background-color: #fff; padding: 0px;">
        <div class="iconbox">
          <button type="button" class="close close-icon" data-dismiss="modal">&times;</button>
        </div>
      </div>
      <div class="modal-body modal-body-change">


        <div class="row">
          <div class="col-md-12">
            <div class="text-center mb-4" style="font-size: 1.4rem; font-weight: 600;"><span style="color: #858585; font-weight: 400;">Price Match Request -</span> {{ref_num}}</div>
            <!--For Service Package Jobs-->
            <div *ngIf="data_res && (line_item_details.service_package_jobs | json) != '{}'">
              <ng-container *ngFor="let key of objectKeys(line_item_details.service_package_jobs); let i=index">
            <div class="sec_style1"><span style="color: #8d0528;">Section:</span> <span style="color: #000;">Service Package</span></div>
            <div class="sec_style1"><span style="color: #8d0528;">Space:</span> <span style="color: #000;">{{key}}</span></div>
            <ng-container *ngFor="let mod of line_item_details.service_package_jobs[key]; let j =index">
            <div class="table_style">
            <table class="" style="width: 100%;">
              <tr>
                <ng-container *ngIf="(role=='business_head' || role == 'city_gm') && job_price_status == 'pending'">
                <th></th>
                </ng-container>
                <th style="font-size: 13px !important; color: #8d0528;">
                  BOQ Line Items
                  </th>
                  <th class="th_style">
                  Amount
                  </th>
                  <th class="th_style">
                  Current Disc. Excl. Price Match
                  </th>
                  <th class="th_style">
                  Current Amount After Disc.
                  </th>
                  <th class="th_style">
                  Price Match Disc. Value
                  </th>
                  <th class="th_style">
                  Price After Disc.
                  </th>
                  <th class="th_style">
                  Requested Price
                  </th>
                </tr>
                <tr>
                  <ng-container *ngIf="(role=='business_head' || role == 'city_gm') && job_price_status == 'pending'">
                  <td class="pl-2" *ngIf="mod.price_match == null"></td>
                  <td class="pl-2" *ngIf="(mod.price_match != null)" ><input type="checkbox" (change)="final_pricecheck(mod.price_match.id, mod.price_match.arrivae_offer_price,$event)"></td>
                  </ng-container>
                  <td style="width: 11rem;">{{mod.name}}</td>
                  <td class="td_style">{{mod.amount | number:'.1-2'}}</td>
                  
                  <td class="td_style">{{mod.current_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_amount_after_discount | number:'.1-2'}}</td>
                  
                  <td class="td_style">{{mod.price_match_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_value | number:'.1-2'}}</td>
                  <td class="td_style pb-2" *ngIf="job_price_status != 'pending'"><input type="number" class="input_style" id="value{{i}}{{j}}" (change)="item_checked('ServiceJob',mod.id,mod.amount,$event.target.value)"/></td>
                  <td class="td_style pb-2" *ngIf="job_price_status == 'pending'">{{mod?.price_match?.arrivae_offer_price}}</td>
                  <!-- <td class="td_style pb-2" *ngIf="job_price_status != 'yet_to_apply' && mod.price_match == null"></td> -->
                  
                  </tr>
              </table>
              </div>
              </ng-container>
              </ng-container>
              </div>
          <!--Service Package Jobs Ends Here-->

          <!--For Custom jab-->
          <div *ngIf="data_res && (line_item_details.custom_jobs | json) != '{}'">
              <ng-container *ngFor="let key of objectKeys(line_item_details.custom_jobs)">
            <div class="sec_style1"><span style="color: #8d0528;">Section:</span> <span style="color: #000;">Custom Element</span></div>
            <div class="sec_style1"><span style="color: #8d0528;">Space:</span> <span style="color: #000;">{{key}}</span></div>
            <ng-container *ngFor="let mod of line_item_details.custom_jobs[key]">
            <div class="table_style">
            <table class="" style="width: 100%;">
              <tr>
                <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                   <th ></th>
                </ng-container>
               
                <th style="font-size: 13px !important; color: #8d0528;">
                  BOQ Line Items
                  </th>
                  <th class="th_style">
                  Amount
                  </th>
                   <th class="th_style">
                  Current Disc. Excl. Price Match
                  </th>
                  <th class="th_style">
                  Current Amount After Disc.
                  </th>
                  <th class="th_style">
                  Price Match Disc. Value
                  </th>
                  <th class="th_style">
                  Price After Disc.
                  </th>
                  <th class="th_style">
                  Requested Price
                  </th>
                </tr>
                <tr>
                  <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                  <td class="pl-2" *ngIf="mod.price_match == null"></td>
                  <td class="pl-2" *ngIf="(mod.price_match != null)"><input type="checkbox" (change)="final_pricecheck(mod.price_match.id, mod.price_match.arrivae_offer_price,$event)"></td>
                  </ng-container>
                  <td style="width: 11rem;">{{mod.name}}</td>
                  <td class="td_style">{{mod.amount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_amount_after_discount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_value | number:'.1-2'}}</td>
                  <td class="td_style pb-2" *ngIf="job_price_status != 'pending'"><input type="number" class="input_style" id="value{{i}}{{j}}" (change)="item_checked('CustomJob',mod.id,mod.amount,$event.target.value)"/></td>
                  <td class="td_style pb-2" *ngIf="job_price_status == 'pending'">{{mod?.price_match?.arrivae_offer_price}}</td>
                  </tr>
              </table>
              </div>
              </ng-container>
              </ng-container>
              </div>

              <!--Custom Job Ends here-->

              <!--For BOQ Job -->
              <div *ngIf="data_res && (line_item_details.boqjobs | json) != '{}'">
              <ng-container *ngFor="let key of objectKeys(line_item_details.boqjobs)">
            <div class="sec_style1"><span style="color: #8d0528;">Section:</span> <span style="color: #000;">Loose Furniture</span></div>
            <div class="sec_style1"><span style="color: #8d0528;">Space:</span> <span style="color: #000;">{{key}}</span></div>
            <ng-container *ngFor="let mod of line_item_details.boqjobs[key]">
            <div class="table_style">
            <table class="" style="width: 100%;">
              <tr>
                <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                   <th></th>
                </ng-container>
                <th style="font-size: 13px !important; color: #8d0528;">
                  BOQ Line Items
                  </th>
                  <th class="th_style">
                  Amount
                  </th>
                  <th class="th_style">
                  Current Disc. Excl. Price Match
                  </th>
                  <th class="th_style">
                  Current Amount After Disc.
                  </th>
                  <th class="th_style">
                  Price Match Disc. Value
                  </th>
                  <th class="th_style">
                  Price After Disc.
                  </th>
                  <th class="th_style">
                  Requested Price
                  </th>
                </tr>
                <tr>
                  <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                  <td class="pl-2" *ngIf="mod.price_match == null"></td>
                  <td class="pl-2" *ngIf="(mod.price_match != null)"><input type="checkbox" (change)="final_pricecheck(mod.price_match.id, mod.price_match.arrivae_offer_price,$event)"></td>
                  </ng-container>
                  <td style="width: 11rem;">{{mod.name}}</td>
                  <td class="td_style">{{mod.amount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_amount_after_discount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_value | number:'.1-2'}}</td>
                  <td class="td_style pb-2" *ngIf="job_price_status != 'pending'"><input type="number" class="input_style" id="value{{i}}{{j}}" (change)="item_checked('Boqjob',mod.id,mod.amount,$event.target.value)"/></td>
                  <td class="td_style pb-2" *ngIf="job_price_status == 'pending'">{{mod?.price_match?.arrivae_offer_price}}</td>
                  </tr>
              </table>
              </div>
              </ng-container>
              </ng-container>
              </div>
              <!--Boq Job Ends here-->

              <!--Service Job-->
            <div *ngIf="data_res && (line_item_details.service_jobs | json) != '{}'">
              <ng-container *ngFor="let key of objectKeys(line_item_details.service_jobs)">
            <div class="sec_style1"><span style="color: #8d0528;">Section:</span> <span style="color: #000;">Service</span></div>
            <div class="sec_style1"><span style="color: #8d0528;">Space:</span> <span style="color: #000;">{{key}}</span></div>
            <ng-container *ngFor="let mod of line_item_details.service_jobs[key]">
            <div class="table_style">
            <table class="" style="width: 100%;">
              <tr>
                <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                   <th></th>
                </ng-container>
                <th style="font-size: 13px !important; color: #8d0528;">
                  BOQ Line Items
                  </th>
                  <th class="th_style">
                  Amount
                  </th>
                  <th class="th_style">
                  Current Disc. Excl. Price Match
                  </th>
                  <th class="th_style">
                  Current Amount After Disc.
                  </th>
                  <th class="th_style">
                  Price Match Disc. Value
                  </th>
                  <th class="th_style">
                  Price After Disc.
                  </th>
                  <th class="th_style">
                  Requested Price
                  </th>
                </tr>
                <tr>
                  <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                  <td class="pl-2" *ngIf="mod.price_match == null"></td>
                  <td class="pl-2" *ngIf="(mod.price_match != null)"><input type="checkbox" (change)="final_pricecheck(mod.price_match.id, mod.price_match.arrivae_offer_price,$event)"></td>
                  </ng-container>
                  <td style="width: 11rem;">{{mod.name}}</td>
                  <td class="td_style">{{mod.amount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_amount_after_discount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_value | number:'.1-2'}}</td>
                  <td class="td_style pb-2" *ngIf="job_price_status != 'pending'"><input type="number" class="input_style" id="value{{i}}{{j}}" (change)="item_checked('ServiceJob',mod.id,mod.amount,$event.target.value)"/></td>
                  <td class="td_style pb-2" *ngIf="job_price_status == 'pending'">{{mod?.price_match?.arrivae_offer_price}}</td>
                  </tr>
              </table>
              </div>
              </ng-container>
              </ng-container>
              </div>
              <!--Service Job Ends here-->

              <!--appliance_jobs-->
          <div *ngIf="data_res && (line_item_details.appliance_jobs | json) != '{}'">
              <ng-container *ngFor="let key of objectKeys(line_item_details.appliance_jobs)">
            <div class="sec_style1"><span style="color: #8d0528;">Section:</span> <span style="color: #000;">Kitchen Appliance</span></div>
            <div class="sec_style1"><span style="color: #8d0528;">Space:</span> <span style="color: #000;">{{key}}</span></div>
            <ng-container *ngFor="let mod of line_item_details.appliance_jobs[key]">
            <div class="table_style">
            <table class="" style="width: 100%;">
              <tr>
                <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                   <th></th>
                </ng-container>
                <th style="font-size: 13px !important; color: #8d0528;">
                  BOQ Line Items
                  </th>
                  <th class="th_style">
                  Amount
                  </th>
                  <th class="th_style">
                  Current Disc. Excl. Price Match
                  </th>
                  <th class="th_style">
                  Current Amount After Disc.
                  </th>
                  <th class="th_style">
                  Price Match Disc. Value
                  </th>
                  <th class="th_style">
                  Price After Disc.
                  </th>
                  <th class="th_style">
                  Requested Price
                  </th>
                </tr>
                <tr>
                   <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                  <td class="pl-2" *ngIf="mod.price_match == null"></td>
                  <td class="pl-2" *ngIf="(mod.price_match != null)"><input type="checkbox" (change)="final_pricecheck(mod.price_match.id, mod.price_match.arrivae_offer_price,$event)"></td>
                  </ng-container>
                  <td style="width: 11rem;">{{mod.name}}</td>
                  <td class="td_style">{{mod.amount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_amount_after_discount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_value | number:'.1-2'}}</td>
                  <td class="td_style pb-2" *ngIf="job_price_status != 'pending'"><input type="number" class="input_style" id="value{{i}}{{j}}" (change)="item_checked('ApplianceJob',mod.id,mod.amount,$event.target.value)"/></td>
                  <td class="td_style pb-2" *ngIf="job_price_status == 'pending'">{{mod?.price_match?.arrivae_offer_price}}</td>
                  </tr>
              </table>
              </div>
              </ng-container>
              </ng-container>
              </div>

              <!--appliance_jobs ends here-->

              <!--extra_jobs_wardrobe-->
              <div *ngIf="data_res && (line_item_details.extra_jobs_wardrobe | json) != '{}'">
              <ng-container *ngFor="let key of objectKeys(line_item_details.extra_jobs_wardrobe)">
            <div class="sec_style1"><span style="color: #8d0528;">Section:</span> <span style="color: #000;">Wardrobe - Extras</span></div>
            <div class="sec_style1"><span style="color: #8d0528;">Space:</span> <span style="color: #000;">{{key}}</span></div>
            <ng-container *ngFor="let mod of line_item_details.extra_jobs_wardrobe[key]">
            <div class="table_style">
            <table class="" style="width: 100%;">
              <tr>
                <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                   <th></th>
                </ng-container>
                <th style="font-size: 13px !important; color: #8d0528;">
                  BOQ Line Items
                  </th>
                  <th class="th_style">
                  Amount
                  </th>
                  <th class="th_style">
                  Current Disc. Excl. Price Match
                  </th>
                  <th class="th_style">
                  Current Amount After Disc.
                  </th>
                  <th class="th_style">
                  Price Match Disc. Value
                  </th>
                  <th class="th_style">
                  Price After Disc.
                  </th>
                  <th class="th_style">
                  Requested Price
                  </th>
                </tr>
                <tr>
                  <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                  <td class="pl-2" *ngIf="mod.price_match == null"></td>
                  <td class="pl-2" *ngIf="(mod.price_match != null)"><input type="checkbox" (change)="final_pricecheck(mod.price_match.id, mod.price_match.arrivae_offer_price,$event)"></td>
                  </ng-container>
                  <td style="width: 11rem;">{{mod.name}}</td>
                  <td class="td_style">{{mod.amount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_amount_after_discount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_value | number:'.1-2'}}</td>
                  <td class="td_style pb-2" *ngIf="job_price_status != 'pending'"><input type="number" class="input_style" id="value{{i}}{{j}}" (change)="item_checked('ExtraJob',mod.id,mod.amount,$event.target.value)"/></td>
                  <td class="td_style pb-2" *ngIf="job_price_status == 'pending'">{{mod?.price_match?.arrivae_offer_price}}</td>
                  </tr>
              </table>
              </div>
              </ng-container>
              </ng-container>
              </div>
              <!--extra_jobs_wardrobe ends-->

              <!--extra_jobs_kitchen-->
              <div *ngIf="data_res && (line_item_details.extra_jobs_kitchen | json) != '{}'">
              <ng-container *ngFor="let key of objectKeys(line_item_details.extra_jobs_kitchen)">
            <div class="sec_style1"><span style="color: #8d0528;">Section:</span> <span style="color: #000;">Kitchen - Extras</span></div>
            <div class="sec_style1"><span style="color: #8d0528;">Space:</span> <span style="color: #000;">{{key}}</span></div>
            <ng-container *ngFor="let mod of line_item_details.extra_jobs_kitchen[key]">
            <div class="table_style">
            <table class="" style="width: 100%;">
              <tr>
                <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                   <th></th>
                </ng-container>
                <th style="font-size: 13px !important; color: #8d0528;">
                  BOQ Line Items
                  </th>
                  <th class="th_style">
                  Amount
                  </th>
                  <th class="th_style">
                  Current Disc. Excl. Price Match
                  </th>
                  <th class="th_style">
                  Current Amount After Disc.
                  </th>
                  <th class="th_style">
                  Price Match Disc. Value
                  </th>
                  <th class="th_style">
                  Price After Disc.
                  </th>
                  <th class="th_style">
                  Requested Price
                  </th>
                </tr>
                <tr>
                  <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                  <td class="pl-2" *ngIf="mod.price_match == null"></td>
                  <td class="pl-2" *ngIf="(mod.price_match != null)"><input type="checkbox" (change)="final_pricecheck(mod.price_match.id, mod.price_match.arrivae_offer_price,$event)"></td>
                  </ng-container>
                  <td style="width: 11rem;">{{mod.name}}</td>
                  <td class="td_style">{{mod.amount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_amount_after_discount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_value | number:'.1-2'}}</td>
                  <td class="td_style pb-2" *ngIf="job_price_status != 'pending'"><input type="number" class="input_style" id="value{{i}}{{j}}" (change)="item_checked('ExtraJob',mod.id,mod.amount,$event.target.value)" /></td>
                  <td class="td_style pb-2" *ngIf="job_price_status == 'pending'">{{mod?.price_match?.arrivae_offer_price}}</td>
                  </tr>
              </table>
              </div>
              </ng-container>
              </ng-container>
              </div>
              <!--extra_jobs_kitchen ends-->

              <!--shangpin_jobs_cabinet-->
              <div *ngIf="data_res && (line_item_details.shangpin_jobs_cabinet | json) != '{}'">
              <ng-container *ngFor="let key of objectKeys(line_item_details.shangpin_jobs_cabinet)">
            <div class="sec_style1"><span style="color: #8d0528;">Section:</span> <span style="color: #000;">Custom Furniture - Cabinet</span></div>
            <div class="sec_style1"><span style="color: #8d0528;">Space:</span> <span style="color: #000;">{{key}}</span></div>
            <ng-container *ngFor="let mod of line_item_details.shangpin_jobs_cabinet[key]">
            <div class="table_style">
            <table class="" style="width: 100%;">
              <tr>
                <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                   <th></th>
                </ng-container>
                <th style="font-size: 13px !important; color: #8d0528;">
                  BOQ Line Items
                  </th>
                  <th class="th_style">
                  Amount
                  </th>
                  <th class="th_style">
                  Current Disc. Excl. Price Match
                  </th>
                  <th class="th_style">
                  Current Amount After Disc.
                  </th>
                  <th class="th_style">
                  Price Match Disc. Value
                  </th>
                  <th class="th_style">
                  Price After Disc.
                  </th>
                  <th class="th_style">
                  Requested Price
                  </th>
                </tr>
                <tr>
                  <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                  <td class="pl-2" *ngIf="mod.price_match == null"></td>
                  <td class="pl-2" *ngIf="(mod.price_match != null)"><input type="checkbox" (change)="final_pricecheck(mod.price_match.id, mod.price_match.arrivae_offer_price,$event)"></td>
                  </ng-container>
                  <td style="width: 11rem;">{{mod.name}}</td>
                  <td class="td_style">{{mod.amount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_amount_after_discount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_value | number:'.1-2'}}</td>
                  <td class="td_style pb-2" *ngIf="job_price_status != 'pending'"><input type="number" class="input_style" id="value{{i}}{{j}}" (change)="item_checked('ShangpinJob',mod.id,mod.amount,$event.target.value)" /></td>
                  <td class="td_style pb-2" *ngIf="job_price_status == 'pending'">{{mod?.price_match?.arrivae_offer_price}}</td>
                  </tr>
              </table>
              </div>
              </ng-container>
              </ng-container>
              </div>
              <!--shangpin_jobs_cabinet ends-->

              <!--shangpin_jobs_door-->
              <div *ngIf="data_res && (line_item_details.shangpin_jobs_door | json) != '{}'">
              <ng-container *ngFor="let key of objectKeys(line_item_details.shangpin_jobs_door)">
            <div class="sec_style1"><span style="color: #8d0528;">Section:</span> <span style="color: #000;">Custom Furniture - Door</span></div>
            <div class="sec_style1"><span style="color: #8d0528;">Space:</span> <span style="color: #000;">{{key}}</span></div>
            <ng-container *ngFor="let mod of line_item_details.shangpin_jobs_door[key]">
            <div class="table_style">
            <table class="" style="width: 100%;">
              <tr>
                <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                   <th></th>
                </ng-container>
                <th style="font-size: 13px !important; color: #8d0528;">
                  BOQ Line Items
                  </th>
                  <th class="th_style">
                  Amount
                  </th>
                  <th class="th_style">
                  Current Disc. Excl. Price Match
                  </th>
                  <th class="th_style">
                  Current Amount After Disc.
                  </th>
                  <th class="th_style">
                  Price Match Disc. Value
                  </th>
                  <th class="th_style">
                  Price After Disc.
                  </th>
                  <th class="th_style">
                  Requested Price
                  </th>
                </tr>
                <tr>
                  <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                  <td class="pl-2" *ngIf="mod.price_match == null"></td>
                  <td class="pl-2" *ngIf="(mod.price_match != null)"><input type="checkbox" (change)="final_pricecheck(mod.price_match.id, mod.price_match.arrivae_offer_price,$event)"></td>
                  </ng-container>
                  <td style="width: 11rem;">{{mod.name}}</td>
                  <td class="td_style">{{mod.amount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_amount_after_discount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_value | number:'.1-2'}}</td>
                  <td class="td_style pb-2" *ngIf="job_price_status != 'pending'"><input type="number" class="input_style" id="value{{i}}{{j}}" (change)="item_checked('ShangpinJob',mod.id,mod.amount,$event.target.value)" /></td>
                  <td class="td_style pb-2" *ngIf="job_price_status == 'pending'">{{mod?.price_match?.arrivae_offer_price}}</td>
                  </tr>
              </table>
              </div>
              </ng-container>
              </ng-container>
              </div>
              <!--shangpin_jobs_door Ends-->

              <!--shangpin_jobs_accessory-->
              <div *ngIf="data_res && (line_item_details.shangpin_jobs_accessory | json) != '{}'">
              <ng-container *ngFor="let key of objectKeys(line_item_details.shangpin_jobs_accessory)">
            <div class="sec_style1"><span style="color: #8d0528;">Section:</span> <span style="color: #000;">Custom Furniture - Accessory</span></div>
            <div class="sec_style1"><span style="color: #8d0528;">Space:</span> <span style="color: #000;">{{key}}</span></div>
            <ng-container *ngFor="let mod of line_item_details.shangpin_jobs_accessory[key]">
            <div class="table_style">
            <table class="" style="width: 100%;">
              <tr>
                <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                   <th></th>
                </ng-container>
                <th style="font-size: 13px !important; color: #8d0528;">
                  BOQ Line Items
                  </th>
                  <th class="th_style">
                  Amount
                  </th>
                  <th class="th_style">
                  Current Disc. Excl. Price Match
                  </th>
                  <th class="th_style">
                  Current Amount After Disc.
                  </th>
                  <th class="th_style">
                  Price Match Disc. Value
                  </th>
                  <th class="th_style">
                  Price After Disc.
                  </th>
                  <th class="th_style">
                  Requested Price
                  </th>
                </tr>
                <tr>
                  <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                  <td class="pl-2" *ngIf="mod.price_match == null"></td>
                  <td class="pl-2" *ngIf="(mod.price_match != null)"><input type="checkbox" (change)="final_pricecheck(mod.price_match.id, mod.price_match.arrivae_offer_price,$event)"></td>
                  </ng-container>
                  <td style="width: 11rem;">{{mod.name}}</td>
                  <td class="td_style">{{mod.amount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_amount_after_discount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_value | number:'.1-2'}}</td>
                  <td class="td_style pb-2" *ngIf="job_price_status != 'pending'"><input type="number" class="input_style" id="value{{i}}{{j}}" (change)="item_checked('ShangpinJob',mod.id,mod.amount,$event.target.value)" /></td>
                  <td class="td_style pb-2" *ngIf="job_price_status == 'pending'">{{mod?.price_match?.arrivae_offer_price}}</td>
                  </tr>
              </table>
              </div>
              </ng-container>
              </ng-container>
              </div>
              <!--shangpin_jobs_accessory ends-->

              <!--shangpin_jobs_sliding_door-->
              <div *ngIf="data_res && (line_item_details.shangpin_jobs_sliding_door | json) != '{}'">
              <ng-container *ngFor="let key of objectKeys(line_item_details.shangpin_jobs_sliding_door)">
            <div class="sec_style1"><span style="color: #8d0528;">Section:</span> <span style="color: #000;">Custom Furniture - Sliding Door</span></div>
            <div class="sec_style1"><span style="color: #8d0528;">Space:</span> <span style="color: #000;">{{key}}</span></div>
            <ng-container *ngFor="let mod of line_item_details.shangpin_jobs_sliding_door[key]">
            <div class="table_style">
            <table class="" style="width: 100%;">
              <tr>
                <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                   <th></th>
                </ng-container>
                <th style="font-size: 13px !important; color: #8d0528;">
                  BOQ Line Items
                  </th>
                  <th class="th_style">
                  Amount
                  </th>
                   <th class="th_style">
                  Current Disc. Excl. Price Match
                  </th>
                  <th class="th_style">
                  Current Amount After Disc.
                  </th>
                  <th class="th_style">
                  Price Match Disc. Value
                  </th>
                  <th class="th_style">
                  Price After Disc.
                  </th>
                  <th class="th_style">
                  Requested Price
                  </th>
                </tr>
                <tr>
                  <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                  <td class="pl-2" *ngIf="mod.price_match == null"></td>
                  <td class="pl-2" *ngIf="(mod.price_match != null)"><input type="checkbox" (change)="final_pricecheck(mod.price_match.id, mod.price_match.arrivae_offer_price,$event)"></td>
                  </ng-container>
                  <td style="width: 11rem;">{{mod.name}}</td>
                  <td class="td_style">{{mod.amount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_amount_after_discount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_value | number:'.1-2'}}</td>
                   <td class="td_style pb-2" *ngIf="job_price_status != 'pending'"><input type="number" class="input_style" id="value{{i}}{{j}}" (change)="item_checked('ShangpinJob',mod.id,mod.amount,$event.target.value)"/></td>
                  <td class="td_style pb-2" *ngIf="job_price_status == 'pending'">{{mod?.price_match?.arrivae_offer_price}}</td>
                  </tr>
              </table>
              </div>
              </ng-container>
              </ng-container>
              </div>
              <!--shangpin_jobs_sliding_door ends-->

              <!--shangpin_jobs_sliding_door-->
              <div *ngIf="data_res && (line_item_details.shangpin_jobs_sliding_door | json) != '{}'">
              <ng-container *ngFor="let key of objectKeys(line_item_details.shangpin_jobs_sliding_door)">
            <div class="sec_style1"><span style="color: #8d0528;">Section:</span> <span style="color: #000;">Custom Furniture - Sliding Door</span></div>
            <div class="sec_style1"><span style="color: #8d0528;">Space:</span> <span style="color: #000;">{{key}}</span></div>
            <ng-container *ngFor="let mod of line_item_details.shangpin_jobs_sliding_door[key]">
            <div class="table_style">
            <table class="" style="width: 100%;">
              <tr>
                <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                   <th></th>
                </ng-container>
                <th style="font-size: 13px !important; color: #8d0528;">
                  BOQ Line Items
                  </th>
                  <th class="th_style">
                  Amount
                  </th>
                  <th class="th_style">
                  Current Disc. Excl. Price Match
                  </th>
                  <th class="th_style">
                  Current Amount After Disc.
                  </th>
                  <th class="th_style">
                  Price Match Disc. Value
                  </th>
                  <th class="th_style">
                  Price After Disc.
                  </th>
                  <th class="th_style">
                  Requested Price
                  </th>
                </tr>
                <tr>
                  <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                  <td class="pl-2" *ngIf="mod.price_match == null"></td>
                  <td class="pl-2" *ngIf="(mod.price_match != null)"><input type="checkbox" (change)="final_pricecheck(mod.price_match.id, mod.price_match.arrivae_offer_price,$event)"></td>
                  </ng-container>
                  <td style="width: 11rem;">{{mod.name}}</td>
                  <td class="td_style">{{mod.amount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_amount_after_discount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_value | number:'.1-2'}}</td>
                  <td class="td_style pb-2" *ngIf="job_price_status != 'pending'"><input type="number" class="input_style" id="value{{i}}{{j}}" (change)="item_checked('ShangpinJob',mod.id,mod.amount,$event.target.value)"/></td>
                  <td class="td_style pb-2" *ngIf="job_price_status == 'pending'">{{mod?.price_match?.arrivae_offer_price}}</td>
                  </tr>
              </table>
              </div>
              </ng-container>
              </ng-container>
              </div>
              <!--shangpin_jobs_sliding_door  ends-->

              <!--shangpin_jobs_wardrobe-->
              <div *ngIf="data_res && (line_item_details.shangpin_jobs_wardrobe | json) != '{}'">
              <ng-container *ngFor="let key of objectKeys(line_item_details.shangpin_jobs_wardrobe)">
            <div class="sec_style1"><span style="color: #8d0528;">Section:</span> <span style="color: #000;">Custom Furniture - Wardrobe</span></div>
            <div class="sec_style1"><span style="color: #8d0528;">Space:</span> <span style="color: #000;">{{key}}</span></div>
            <ng-container *ngFor="let mod of line_item_details.shangpin_jobs_wardrobe[key]">
            <div class="table_style">
            <table class="" style="width: 100%;">
              <tr>
                <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                   <th></th>
                </ng-container>
                <th style="font-size: 13px !important; color: #8d0528;">
                  BOQ Line Items
                  </th>
                  <th class="th_style">
                  Amount
                  </th>
                 <th class="th_style">
                  Current Disc. Excl. Price Match
                  </th>
                  <th class="th_style">
                  Current Amount After Disc.
                  </th>
                  <th class="th_style">
                  Price Match Disc. Value
                  </th>
                  <th class="th_style">
                  Price After Disc.
                  </th>
                  <th class="th_style">
                  Requested Price
                  </th>
                </tr>
                <tr>
                  <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                  <td class="pl-2" *ngIf="mod.price_match == null"></td>
                  <td class="pl-2" *ngIf="(mod.price_match != null)"><input type="checkbox" (change)="final_pricecheck(mod.price_match.id, mod.price_match.arrivae_offer_price,$event)"></td>
                  </ng-container>
                  <td style="width: 11rem;">{{mod.name}}</td>
                  <td class="td_style">{{mod.amount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_amount_after_discount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_value | number:'.1-2'}}</td>
                  <td class="td_style pb-2" *ngIf="job_price_status != 'pending'"><input type="number" class="input_style" id="value{{i}}{{j}}" (change)="item_checked('ShangpinJob',mod.id,mod.amount,$event.target.value)" /></td>
                  <td class="td_style pb-2" *ngIf="job_price_status == 'pending'">{{mod?.price_match?.arrivae_offer_price}}</td>
                  </tr>
              </table>
              </div>
              </ng-container>
              </ng-container>
              </div>
              <!--shangpin_jobs_wardrobe ends-->

              <!--modular_jobs_wardrobe-->
              <div *ngIf="data_res && (line_item_details.modular_jobs_wardrobe | json) != '{}'">
              <ng-container *ngFor="let key of objectKeys(line_item_details.modular_jobs_wardrobe)">
            <div class="sec_style1"><span style="color: #8d0528;">Section:</span> <span style="color: #000;">Modular Wardrobe</span></div>
            <div class="sec_style1"><span style="color: #8d0528;">Space:</span> <span style="color: #000;">{{key}}</span></div>
            <ng-container *ngFor="let mod of line_item_details.modular_jobs_wardrobe[key]">
            <div class="table_style">
            <table class="" style="width: 100%;">
              <tr>
               <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                   <th></th>
                </ng-container>
                <th style="font-size: 13px !important; color: #8d0528;">
                  BOQ Line Items
                  </th>
                  <th class="th_style">
                  Amount
                  </th>
                  <th class="th_style">
                  Current Disc. Excl. Price Match
                  </th>
                   <th class="th_style">
                  Current Amount After Disc.
                  </th>
                  <th class="th_style">
                  Price Match Disc. Value
                  </th>
                  <th class="th_style">
                  Price After Disc.
                  </th>
                  <th class="th_style">
                  Requested Price
                  </th>
                </tr>
                <tr>
                  <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                  <td class="pl-2" *ngIf="mod.price_match == null"></td>
                  <td class="pl-2" *ngIf="(mod.price_match != null)"><input type="checkbox" (change)="final_pricecheck(mod.price_match.id, mod.price_match.arrivae_offer_price,$event)"></td>
                  </ng-container>
                  <td style="width: 11rem;">{{mod.name}}</td>
                  <td class="td_style">{{mod.amount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_discount_value | number:'.1-2'}}</td>
                 <td class="td_style">{{mod.current_amount_after_discount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_discount_value | number:'.1-2'}}</td>
                   <td class="td_style">{{mod.price_match_value | number:'.1-2'}}</td>
                  <td class="td_style pb-2" *ngIf="job_price_status != 'pending'"><input type="number" class="input_style" id="value{{i}}{{j}}" (change)="item_checked('ModularJob',mod.id,mod.amount,$event.target.value)"/></td>
                  <td class="td_style pb-2" *ngIf="job_price_status == 'pending'">{{mod?.price_match?.arrivae_offer_price}}</td>
                  </tr>
              </table>
              </div>
              </ng-container>
              </ng-container>
              </div>
              <!--modular_jobs_wardrobe ends-->

              <!--modular_jobs_kitchen-->
              <div *ngIf="data_res && (line_item_details.modular_jobs_kitchen | json) != '{}'">
              <ng-container *ngFor="let key of objectKeys(line_item_details.modular_jobs_kitchen)">
            <div class="sec_style1"><span style="color: #8d0528;">Section:</span> <span style="color: #000;">Modular Kitchen</span></div>

            <div class="sec_style1"><span style="color: #8d0528;">Space:</span> <span style="color: #000;">{{key}}</span></div>
            <ng-container *ngFor="let mod of line_item_details.modular_jobs_kitchen[key]">
            <div class="table_style">
            <table class="" style="width: 100%;">
              <tr>
                <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                   <th></th>
                </ng-container>
                <th style="font-size: 13px !important; color: #8d0528;">
                  BOQ Line Items
                  </th>
                  <th class="th_style">
                  Amount
                  </th>
                  <th class="th_style">
                  Current Disc. Excl. Price Match
                  </th>
                  <th class="th_style">
                  Current Amount After Disc.
                  </th>
                  <th class="th_style">
                  Price Match Disc. Value
                  </th>
                  <th class="th_style">
                  Price After Disc.
                  </th>
                  <th class="th_style">
                  Requested Price
                  </th>
                </tr>
                <tr>
                  <ng-container *ngIf="role=='business_head' || role == 'city_gm'">
                  <td class="pl-2" *ngIf="mod.price_match == null"></td>
                  <td class="pl-2" *ngIf="(mod.price_match != null)"><input type="checkbox" (change)="final_pricecheck(mod.price_match.id, mod.price_match.arrivae_offer_price,$event)"></td>
                  </ng-container>
                  <td style="width: 11rem;">{{mod.name}}</td>
                  <td class="td_style">{{mod.amount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.current_amount_after_discount | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_discount_value | number:'.1-2'}}</td>
                  <td class="td_style">{{mod.price_match_value | number:'.1-2'}}</td>
                  <td class="td_style pb-2" *ngIf="job_price_status != 'pending'"><input type="number" class="input_style" id="value{{i}}{{j}}" (change)="item_checked('ModularJob',mod.id,mod.amount,$event.target.value)"/></td>
                  <td class="td_style pb-2" *ngIf="job_price_status == 'pending'">{{mod?.price_match?.arrivae_offer_price}}</td>
                  </tr>
              </table>
              </div>
              </ng-container>
              </ng-container>
              </div>
              <!--modular_jobs_kitchen ends-->
              <div class="table_style">
              <table style="width: 100%">
                <tr>
                  <th class="th_style" style="font-size: 12px !important;"></th>
                  <th class="th_style" style="font-size: 12px !important; text-align: center !important;">Total Amount</th>
                  <th class="th_style" style="font-size: 12px !important; text-align: center !important;">Total Cur. Disc. Excl. Price Match</th>
                  <th class="th_style" style="font-size: 12px !important; text-align: center !important;">Total Cur. Amount After Disc.</th>
                  <th class="th_style" style="font-size: 12px !important; text-align: center !important;">Total Price Match Value</th>
                  <th class="th_style" style="font-size: 12px !important; text-align: center !important; ">Total Price After Disc.</th>
                  <th class="th_style" style="font-size: 12px !important; text-align: end !important;">Total Req. Price</th>
                  </tr>
                <tr>
                  <!-- <td style="padding-left: 4.5rem;"></td> -->
                  <td class="" style="color: #8d0528; font-size: 13px; width: 12%;">Total:</td>
                  <td class="" style=" font-size: 13px; text-align: center;">{{total_price | currency :'INR':'symbol':'1.2-2'}}</td>
                  <td class="" style="font-size: 12px; text-align: center;">{{total_2nd | currency :'INR':'symbol':'1.2-2'}}<div *ngIf="promotion_applied?.promotion_applied || promotion_applied?.discount"> &nbsp;({{promotion_applied?.promotion_applied + promotion_applied?.discount}} % Promo Disc. Applied)</div></td>
                  <td class="" style="font-size: 13px; text-align: center;">{{total_3rd | currency :'INR':'symbol':'1.2-2'}}</td>
                  <td class="" style="font-size: 13px; text-align: center;">{{total_4th | currency :'INR':'symbol':'1.2-2'}}</td>
                  <!-- <td class="" style="width: 13%;">{{total_5th | currency :'INR':'symbol':'1.2-2'}}</td> -->
                  <td class="" style="text-align: center; font-size: 12px;">{{discounted_price | currency :'INR':'symbol':'1.2-2'}}<div *ngIf="promotion_applied?.total_discount"> &nbsp;({{promotion_applied?.total_discount}} % Disc. Applied)</div><div *ngIf="promotion_applied?.discount">Disc. % - {{promotion_applied?.discount}}%</div><div *ngIf="promotion_applied?.promotion_applied">Promo. Applied - {{promotion_applied?.promotion_applied}}%</div><div *ngIf="(job_price_status != 'yet_to_apply' || job_price_status != 'pending') && (promotion_applied?.price_match_discount != 0)">Price Match Disc. % - {{promotion_applied?.price_match_discount}}%</div></td>
                  <td style="text-align: end; font-size: 12px;" class="" >{{job_price_match?.job_price_match_boq_value | currency :'INR':'symbol':'1.2-2'}}<div *ngIf="job_price_match?.job_price_match_percentage"> &nbsp;({{job_price_match?.job_price_match_percentage}} % Disc. Applied)</div></td>
                  </tr>
              </table>
              </div>
              <div class="row">
                <div class="col-md-8">
                <ng-container *ngIf="job_price_status == 'yet_to_apply'">
                <label id="getFileLabel" for="getFile" class="Upload_btn compet_style">Upload Competitor Quote</label>
                <input type="file" id="getFile" multiple style="display: none;" (change)="uploadCV($event)" />
                <span *ngIf="submitted_file_amount > 0"><span style="color: #8d0528;">Files Uploaded:</span> {{submitted_file_amount}}</span> <br>
                  <label> Competitor Name  </label>
                   <select class="downloadBtn filter-status ml-2 " (change)="CnameStatus($event)" [(ngModel)]="SelectCname" style="height: 36px;">
            <option selected value="">
          Select Competitor Name
        </option>
        <ng-container *ngFor="let comp of allcomps" >
 <option  value="{{comp}}"  >
         {{comp | titlecase}}
        </option>
      </ng-container>
         <option value="others">
          Others
        </option>
      </select> 
      <div *ngIf="SelectCname ==  'others'" style="width: 200px;" class="mt-2 d-inline-block ml-2"><div class="form-group purple-border">
 <input type="text" class="form-control"  placeholder="Other Competitor Name "  [(ngModel)] ="compothername">
</div></div>
   
      
                  </ng-container>
                  <ng-container *ngIf="job_price_status == 'pending'">
                    <span>Files Uploaded:</span>
                  <ng-container *ngFor="let file of files_uploaded; let k=index">
                    <a target="_blank" href="{{file}}"><span style="color: #8d0528;">File {{k+1}}</span></a>
                    </ng-container><br>
                     <label> Competitor Name  </label>
                        <select class="downloadBtn filter-status ml-2" disabled (change)="CnameStatus($event)" [(ngModel)]="SelectCname" style="height: 36px;">
            <option selected value="">
          Select Competitor Name
        </option>
        <ng-container *ngFor="let comp of allcomps" >
 <option  value="{{comp}}"  >
         {{comp | titlecase}}
        </option>
      </ng-container>
         <option value="others">
          Others
        </option>
      </select>
      
                   
                  </ng-container>
                  <ng-container *ngIf="job_price_status == 'approved' || job_price_status == 'rejected'">
                <label id="getFileLabel" for="getFile" class="Upload_btn compet_style">Upload Competitor Quote</label>
                <input type="file" id="getFile" multiple style="display: none;" (change)="uploadCV($event)" />
                <span *ngIf="submitted_file_amount > 0"><span style="color: #8d0528;">Files Uploaded:</span> {{submitted_file_amount}}</span> 
                <ng-container *ngFor="let file of files_uploaded; let k=index">
                    <a target="_blank" href="{{file}}"><span style="color: #8d0528;">File {{k+1}}</span></a>
                     
                    </ng-container>
                    <br>
                     <label> Competitor Name  </label>
                    
                     <select class="downloadBtn filter-status ml-2 " (change)="CnameStatus($event)" [(ngModel)]="SelectCname" style="height: 36px;">
            <option selected value="">
          Select Competitor Name 
        </option>
        <ng-container *ngFor="let comp of allcomps" >
 <option  value="{{comp}}"  >
         {{comp | titlecase}}
        </option>
      </ng-container>
         <option value="others">
          Others
        </option>
      </select> 
      <div *ngIf="SelectCname ==  'others'" style="width: 200px;" class="mt-2 d-inline-block ml-2"><div class="form-group purple-border">
 <input type="text" class="form-control"  placeholder="Other Competitor Name "  [(ngModel)] ="compothername">
</div></div>
                    
                  </ng-container>
                </div>
                <div class="col-md-4 d-flex align-items-end justify-content-end">
                  <ng-container *ngIf="job_price_status == 'yet_to_apply' || job_price_status == 'approved' || job_price_status == 'rejected'">
                <button [disabled]="attachement_files.length == 0 || final_obj_push.length == 0 || SelectCname == '' || (SelectCname == 'others' && compothername == '')  " class="btn btn_submit mr-3" (click)="submit_price()">Submit</button>
                <!-- <span class="mr-3" style="color: #8d0528; font-size: 19px;" *ngIf="job_price_status == 'pending'">Price Match Requested</span> -->
                </ng-container>
                <ng-container *ngIf="job_price_status == 'pending'">
                <!-- <button *ngIf="role == 'designer' ||
          role == 'community_manager'" class="btn btn_submit mr-3" style="cursor: pointer;" (click)="submit_price()">Submit</button> -->
          <span *ngIf="role == 'designer' ||
          role == 'community_manager'" class="mr-3" style="color: #8d0528; font-size: 19px;">Price Match Requested</span>
                <!-- <span class="mr-3" style="color: #8d0528; font-size: 19px;" *ngIf="job_price_status == 'pending'">Price Match Requested</span> -->
                <button *ngIf="role == 'city_gm' ||
          role == 'business_head'" class="btn btn_approve mr-3" (click)="submit_final_price_approve()" [disabled]="submit_obj_push.length == 0">Approve</button>
                <button *ngIf="role == 'city_gm' ||
          role == 'business_head'" class="btn btn_reject mr-3" (click)="submit_final_price_reject()" [disabled]="submit_obj_push.length == 0">Reject</button>
                </ng-container>
                
                <button *ngIf="job_price_status != 'pending'" class="btn btn_cancel" style="cursor: pointer;" (click)="remove_cancel()">Cancel</button>
                </div>
                </div>
          </div>
          <!-- <div class="col-md-12 text-right" *ngIf="boqProducts && boqProducts.length>0">

            <button class="btn  interalBtnColor addCursor mt-2" (click)="savePayment()"
              [disabled]="!paymentForm.valid">Add Payment</button>

          </div> -->


        </div>
      </div>

    </div>
  </div>
</div>
<!-- Modal end here -->



<!-- Modal create for payment -->
<div id="addPayment" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">


    <div class="modal-content modal-change">
      <div class="modal-header modal-header-chng">
        <h4 class="modal-title modal-title-change">Add Payment Details</h4>
        <div class="iconbox">
          <button type="button" class="close close-icon" data-dismiss="modal">&times;</button>
        </div>
      </div>
      <div class="modal-body modal-body-change">


        <div class="row">
          <div class="col-md-12">
            <form [formGroup]="paymentForm">
              <select formControlName="payment_type" class="form-control mb-2">
                <option [selected]="true">Select Payment Type</option>
                <option value="initial_design">Initial Design</option>
                <option value="final_design">Final Design</option>
              </select>
              <!-- <input type="text" class="form-control mb-2" placeholder="Remarks" formControlName = "quotations"> -->
              <input type="text" class="form-control mb-2" placeholder="Paid Amount" formControlName="paid_amount">
              <select formControlName="mode_of_payment" class="form-control mb-2" (change)="changePaymentMode($event)">
                <option [selected]="true" disabled="true">Select Payment Mode</option>
                <option value="NEFT/RTGS">NEFT/RTGS</option>
                <option value="cheque">Cheque</option>
              </select>

              <input type="text" class="form-control mb-2 cheque-mode" placeholder="Bank Name" formControlName="bank">
              <input type="text" class="form-control mb-2 cheque-mode" placeholder="Branch Name"
                formControlName="branch">
              <label class="cheque-mode">Date of cheque</label>
              <input type="date" class="form-control mb-2 cheque-mode" formControlName="date_of_checque">
              <label class="cheque-mode">Upload Image*</label>
              <input type="file" class="form-control cheque-mode" formControlName="image" (change)="onChange($event)">
              <label class="neft-mode">Payment Date</label>
              <input type="date" class="form-control mb-2 neft-mode" formControlName="date">
            </form>
            <!-- <pre>
            {{paymentForm.value | json}}
          </pre> -->
          </div>
          <div class="col-md-12 text-right" *ngIf="boqProducts && boqProducts.length>0">
            <!-- <button class="btn  interalBtnColor addCursor mt-2 ml-3" (click)="saveProposal('draft')" >Draft</button> -->
            <button class="btn  interalBtnColor addCursor mt-2" (click)="savePayment()"
              [disabled]="!paymentForm.valid">Add Payment</button>

          </div>


        </div>
      </div>

    </div>
  </div>
</div>

<!-- Modal end here -->

<!-- Modal view for history -->
<div id="paymentHistory" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <div class="modal-content modal-change">
      <div class="modal-header modal-header-chng">
        <h4 class="modal-title modal-title-change">Payment History</h4>
        <div class="iconbox">
          <button type="button" class="close close-icon" data-dismiss="modal">&times;</button>
        </div>
      </div>
      <div class="modal-body modal-body-change">
        <div class="row">
          <div class="col-md-12" *ngIf="payment_history_list && payment_history_list.length>0">
            <table class="table ">
              <thead class="thead-dark">
                <tr>
                  <th scope="col" class="firstTh">#</th>
                  <th scope="col">DATE/DATE OF CHEQUE</th>
                  <th scope="col">PAYMENT MODE</th>
                  <th scope="col">BOQ AMOUNT</th>
                  <th scope="col">AMT TO BE PAID</th>
                  <th scope="col">PAID AMT<br><span>(by customer)</span></th>
                  <th scope="col">BANK NAME</th>
                  <th scope="col">BRANCH NAME</th>
                  <th scope="lastTh">PAYMENT TYPE</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let history of payment_history_list; let i = index; " [attr.data-index]="i"
                  class="box-list">
                  <td>{{ i +1 }}</td>
                  <td>
                    <span *ngIf="history.date">{{history.date | date:'fullDate'}}</span>
                    <span *ngIf="history.date_of_checque">{{history.date_of_checque}}</span>
                  </td>

                  <td *ngIf="history.mode_of_payment != 'cheque' ">{{history.mode_of_payment}}</td>
                  <td *ngIf="history.mode_of_payment == 'cheque' "><a href="{{ history.image }}" target="_blank"
                      style="color: #007bff">{{history.mode_of_payment}} </a></td>
                  <!-- <td>{{payment.bank}}</td> -->

                  <td>{{history.total_amount}}</td>
                  <td>{{history.amount_to_be_paid}}</td>
                  <td>{{history.amount}}</td>
                  <td>{{history.bank}}</td>
                  <td class="capitalize">{{history.branch}}</td>
                  <td>{{history.payment_type | replaceChar}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-12 not-found " *ngIf="payment_history_list && payment_history_list.length==0 ">
            <div class="boq-img">
              <img src="../../../assets/img/desktop.png" style="height: 250px;width: 300px">
            </div>
            <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">Nothing to show...</p>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal end here -->

<!-- Modal create for proposal Update -->
<div id="myProposal" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <div class="rk-ui-notification" *ngIf="successalert">
      <span id="notificationMessageText">{{successMessage}}</span>
      <a class="close rk-linknotification" (click)="successalert=false">×</a>
    </div>


    <div class="modal-content modal-change">
      <div class="modal-header modal-header-chng">
        <h4 class="modal-title modal-title-change">Edit Proposal</h4>
        <div class="iconbox">
          <button type="button" class="close close-icon" data-dismiss="modal">&times;</button>
        </div>
      </div>
      <div class="modal-body modal-body-change">
        <div class="row" style="height: 100px;">
          <div class="col-md-6">
            <span class="an-textColor">Choose from :</span><br>
            <select class="form-control selectCatalogue ml-2" (change)="setProposal($event.target.value)">
              <option>Change Proposal</option>
              <option value="boq">BOQ</option>
              <option value="ppt">PPT</option>
            </select>
            <i class="downArrow fa fa-angle-down"></i>
          </div>

        </div>

        <div class="container-fluid container-fluid-chng">
          <div class="row">
            <div class="col-md-6 border-chng">
              <div class="proposalList proposal-chng" *ngIf="proposal_status == 'boq'">
                <div *ngFor="let obj of quotation;let i = index" [attr.data-index]="i">
                  <div class="proposalBox addShadow mr-3 mb-3 {{ obj.id }}" (click)="selectDiv(obj,i)"
                    id="props_{{ obj.id }}">
                    <div class="row">
                      <div class="col-12">
                        <div class="proposalBoxBody">
                          <h6 class="mb-0 mt-1 font-chng "><a>{{ obj.reference_number }}</a></h6>
                          <p class="mb-2">Price: {{ obj.net_amount }}</p>
                          <span class="mb-0">Last Updated{{ obj.updated_at | date:"dd MMMM, y"}}</span>
                        </div>
                      </div>
                      <div class="col-md-3 pull-left d-none">
                        <label class="form-check-label" for="obj{{obj.status}}">
                          <input class="form-check-input boq-checkbox" type="checkbox" id="obj{{obj.id}}"
                            name="obj{{obj.id}}" [checked]="obj.checked">
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-3" *ngIf="proposal_status == 'ppt'">
                <div class="col-md-6 pull-left">
                  <span class="color-chng" *ngIf="pptList">Created PPT</span>
                </div>

              </div>

              <div class="proposalList proposal-chng" *ngIf="proposal_status == 'ppt'">
                <div *ngFor="let obj of pptList;let i = index" [attr.data-index]="i">
                  <div class="proposalBox addShadow mr-3 mb-3 {{ obj.id }}" (click)="selectDiv1(obj,i)">
                    <div class="row myHeight">
                      <div class="col-3 text-center px-2">
                        <div class="proposalBoxImg1">
                          <img class="img-fluid" src="../../../assets/img/customer/PPT.svg">
                          <label class="form-check-label" for="obj{{obj.status}}">
                            <input class="form-check-input d-none ppt-checkbox" type="checkbox" id="obj{{obj.id}}"
                              name="tagOptions" [checked]="obj.checked">

                          </label>
                        </div>
                      </div>
                      <div class="col-9 pl-0">
                        <div class="proposalBoxBody">
                          <h6 class="mb-0 mt-1 font-chng ">{{ obj.title | replaceChar }}</h6>
                          <span class="mb-0">Last Updated:{{ obj.updated_at | date:"dd MMMM, y" }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-3" *ngIf="proposal_status == 'ppt'">
                <div class="col-md-6 pull-left">
                  <span class="color-chng" *ngIf="uploaded_ppt_list">Uploaded PPT</span>
                </div>

              </div>

              <div class="proposalList proposal-chng modal-body-change1" *ngIf="proposal_status == 'ppt'">

                <div *ngFor="let obj of uploaded_ppt_list;let i = index" [attr.data-index]="i">
                  <div class="proposalBox addShadow mr-3 mb-3 {{ obj.uploaded_presentation.id }}"
                    (click)="selectDiv2(obj,i)">
                    <div class="row myHeight">
                      <div class="col-3 text-center px-2">
                        <div class="proposalBoxImg1">
                          <img class="img-fluid" src="../../../assets/img/customer/PPT.svg">
                          <label class="form-check-label" for="obj{{obj.status}}">
                            <input class="form-check-input d-none ppt-checkbox" type="checkbox"
                              id="obj{{obj.uploaded_presentation.id}}" name="tagOptions" [checked]="obj.checked">

                          </label>
                        </div>
                      </div>
                      <div class="col-9 pl-0">
                        <div class="proposalBoxBody">
                          <h6 class="mb-0 mt-1 font-chng ">{{ obj.uploaded_presentation.name | replaceChar }}</h6>
                          <span class="mb-0">Last
                            Updated:{{ obj.uploaded_presentation.updated_at | date:"dd MMMM, y" }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="col-md-6">
              <div class="tableDiv"
                *ngIf="(pptEdit_list && pptEdit_list.length>0) || (ppt_value && ppt_value.length>0)">
                <div class="table-responsive">
                  <table class="table ">
                    <thead class="thead-dark">
                      <tr>
                        <th>#</th>
                        <th>TITLE</th>
                        <th>UPDATED AT</th>

                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container>
                        <tr *ngFor="let obj of pptEdit_list;let i = index" [attr.data-index]="i">

                          <td>{{ i+1 }}</td>
                          <td><a target="_blank"
                              [routerLink]="['/projects',project_id,'presentation',obj.presentation.id,'edit']"
                              routerLinkActive="active" (click)="modalhide()">{{ obj.presentation.title }}</a></td>
                          <td>{{ obj.presentation.updated_at | date:"dd MMMM, y @ h:mma"}}</td>

                          <td>
                            <div>
                              <i class="ion-android-more-vertical  ss-3-dot-drop" data-toggle="dropdown" href="#"
                                role="button" aria-haspopup="true" aria-expanded="false"></i>
                              <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                <a class="dropdown-item addCursor"
                                  (click)="deletEditPpt(obj.proposed_doc_id,obj)">Delete</a>
                                <!--  <a class="dropdown-item addCursor" (click)="discountValue(addedproduct.id)">Discount</a> -->
                              </div>
                            </div>

                          </td>

                        </tr>
                      </ng-container>
                      <ng-container *ngIf="editPptFlag">
                        <tr *ngFor="let obj of ppt_value;let i = index" [attr.data-index]="i">

                          <td>{{ i+1 }}</td>
                          <td><a target="_blank" [routerLink]="['/projects',project_id,'presentation',obj.id,'edit']"
                              routerLinkActive="active" (click)="modalhide()">{{ obj.title }}</a></td>
                          <td>{{ obj.updated_at | date:"dd MMMM, y @ h:mma"}}</td>

                          <td>
                            <div>
                              <i class="ion-android-more-vertical  ss-3-dot-drop" data-toggle="dropdown" href="#"
                                role="button" aria-haspopup="true" aria-expanded="false"></i>
                              <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                <a class="dropdown-item addCursor"
                                  (click)="deletEditPpt(obj.proposed_doc_id,obj)">Delete</a>
                                <!--  <a class="dropdown-item addCursor" (click)="discountValue(addedproduct.id)">Discount</a> -->
                              </div>
                            </div>

                          </td>

                        </tr>

                      </ng-container>
                    </tbody>
                  </table>

                </div>
              </div>
              <div class="tableDiv"
                *ngIf="(uploaded_ppt_list && uploaded_ppt_list.length>0) || (uploaded_ppt_value && uploaded_ppt_value.length>0)">
                <div class="table-responsive">
                  <table class="table ">
                    <thead class="thead-dark">
                      <tr>
                        <th>#</th>
                        <th>TITLE</th>
                        <th>UPDATED AT</th>

                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container>
                        <tr *ngFor="let obj of uploaded_ppt_list;let i = index" [attr.data-index]="i">

                          <td>{{ i+1 }}</td>
                          <td><a>{{ obj.uploaded_presentation.name }}</a></td>
                          <td>{{ obj.uploaded_presentation.updated_at | date:"dd MMMM, y @ h:mma"}}</td>

                          <td>
                            <div>
                              <i class="ion-android-more-vertical  ss-3-dot-drop" data-toggle="dropdown" href="#"
                                role="button" aria-haspopup="true" aria-expanded="false"></i>
                              <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                <a class="dropdown-item addCursor"
                                  (click)="deletEditUploadedPpt(obj.proposed_doc_id,obj)">Delete</a>
                                <!--  <a class="dropdown-item addCursor" (click)="discountValue(addedproduct.id)">Discount</a> -->
                              </div>
                            </div>

                          </td>

                        </tr>
                      </ng-container>
                      <ng-container *ngIf="editPptFlag1">
                        <tr *ngFor="let obj of uploaded_ppt_value;let i = index" [attr.data-index]="i">

                          <td>{{ i+1 }}</td>
                          <td><a>{{ obj.uploaded_presentation.name }}</a></td>
                          <td>{{ obj.uploaded_presentation.updated_at | date:"dd MMMM, y @ h:mma"}}</td>

                          <td>
                            <div>
                              <i class="ion-android-more-vertical  ss-3-dot-drop" data-toggle="dropdown" href="#"
                                role="button" aria-haspopup="true" aria-expanded="false"></i>
                              <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                <a class="dropdown-item addCursor"
                                  (click)="deletEditUploadedPpt(obj.proposed_doc_id,obj)">Delete</a>
                                <!--  <a class="dropdown-item addCursor" (click)="discountValue(addedproduct.id)">Discount</a> -->
                              </div>
                            </div>

                          </td>

                        </tr>

                      </ng-container>
                    </tbody>
                  </table>

                </div>
              </div>


              <div class="tableDiv " *ngIf="boqProductsList && boqProductsList.length>0">
                <div class="table-responsive">
                  <table class="table ">
                    <thead class="thead-dark">
                      <tr>
                        <th scope="col" class="firstTh">#</th>
                        <th scope="col">REFERENCE NUMBER</th>
                        <th scope="col">STATUS</th>
                        <th scope="col">PRICE</th>
                        <th scope="col">PERCENT DISCOUNT</th>
                        <th scope="col">FINAL AMOUNT</th>
                        <th class="lastTh"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container>
                        <tr *ngFor="let addedproduct of boqProductsList; let i = index; " [attr.data-index]="i"
                          class="box-list">
                          <td>{{ i +1 }}</td>
                          <td>{{addedproduct.quotation.reference_number}}</td>
                          <td>{{ addedproduct.quotation.status }}</td>
                          <td>{{ addedproduct.quotation.net_amount }}</td>
                          <td id="prod_{{addedproduct.id}}"><input type="number" min="0" max="10"
                              onkeypress="return event.charCode >= 48" class="discountInput form-control"
                              id="product_{{addedproduct.quotation.id}}" value="{{ addedproduct.discount_value }}"
                              (input)="onInputEditDiscount($event.target.id,addedproduct,i,addedproduct.quotation.id)">
                          </td>
                          <td>{{ total_amount[i] |  number : '1.2-2'}}</td>
                          <td>
                            <div id="dot_{{ addedproduct.id}}">
                              <i class="ion-android-more-vertical  ss-3-dot-drop" data-toggle="dropdown" href="#"
                                role="button" aria-haspopup="true" aria-expanded="false"></i>
                              <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                <a class="dropdown-item addCursor"
                                  (click)="deletEditBoq(addedproduct.proposed_doc_id,addedproduct)">Delete</a>
                                <!--  <a class="dropdown-item addCursor" (click)="discountValue(addedproduct.id)">Discount</a> -->
                              </div>
                            </div>

                          </td>
                          <!-- <td> <i class="fa fa-trash deleteRow addCursor" id="delete_row{{i}}" (click)="removeProductToProposals(addedproduct.id)"></i></td> -->

                        </tr>
                      </ng-container>
                      <ng-container *ngIf="editFlag">
                        <tr *ngFor="let addedproduct of boqEditProducts; let i = index; " [attr.data-index]="i"
                          class="box-list">
                          <td>{{ i +1 }}</td>
                          <td>{{addedproduct.reference_number}}</td>
                          <td>{{ addedproduct.status }}</td>
                          <td>{{ addedproduct.net_amount }}</td>
                          <td id="prod_{{addedproduct.id}}"><input type="number" min="0" max="10"
                              onkeypress="return event.charCode >= 48" class="discountInput form-control"
                              id="product_{{addedproduct.id}}"
                              (input)="onInputDiscountCahnge($event.target.id,addedproduct,i,addedproduct.id)"></td>
                          <td>{{ final_edit_amt[i] |  number : '1.2-2'}}</td>
                          <td>
                            <div id="dot_{{ addedproduct.id}}">
                              <i class="ion-android-more-vertical  ss-3-dot-drop" data-toggle="dropdown" href="#"
                                role="button" aria-haspopup="true" aria-expanded="false"></i>
                              <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                                <a class="dropdown-item addCursor" (click)="deleteBoq(addedproduct)">Delete</a>
                                <!--  <a class="dropdown-item addCursor" (click)="discountValue(addedproduct.id)">Discount</a> -->
                              </div>
                            </div>

                          </td>
                          <!-- <td> <i class="fa fa-trash deleteRow addCursor" id="delete_row{{i}}" (click)="removeProductToProposals(addedproduct.id)"></i></td> -->

                        </tr>
                      </ng-container>

                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-md-12 not-found "
                *ngIf="boqProducts && boqProducts.length==0 && proposal_status == 'boq' ">
                <div class="boq-img">
                  <img src="../../../assets/img/desktop.png" style="height: 250px;width: 300px">
                </div>
                <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">Nothing to show...</p>
              </div>
              <div class="col-md-12 not-found " *ngIf="ppt_value && ppt_value.length==0 && proposal_status == 'ppt' ">
                <div class="boq-img">
                  <img src="../../../assets/img/desktop.png" style="height: 250px;width: 300px">
                </div>
                <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">Nothing to show...</p>
              </div>

            </div>


          </div>
        </div>
        <div class="row">
          <div class="col-md-6">

          </div>
          <div class="col-md-6 pull-left brd-chng" *ngIf="boqProducts && boqProducts.length>0">
            <button class="btn  interalBtnColor addCursor mt-2 " style="margin-left: 300px"
              (click)="saveProposal('draft')">Draft</button>
            <button class="btn  interalBtnColor addCursor mt-2" (click)="saveProposal()">Save</button>

          </div>


        </div>
      </div>

    </div>
  </div>
</div>
<!-- Modal end here -->





// WEBPACK FOOTER //
// ./src/app/platform/lead/view-proposal/view-proposal.component.html